import axios from "axios";
import _ from "lodash";
import Vue from 'vue'
import StudyEstEukTechMapCommissionApiService from "../../../components/application/study/Services/Api/StudyEstEukTechMapCommissionApi";
import store from "../index.js.erb";

const StudyEstEukTechMapCommissionApi = StudyEstEukTechMapCommissionApiService

const StudyEstEukTechMapCommissionStore = {
    namespaced: true,
    state: {
        data_comment: {},
        list_comments: []
    },

    getters: {
    },

    mutations: {
        setDataComment(state, current_commission_comment){
            state.data_comment = current_commission_comment
        },
        setListComments(state, list_comments){
            state.list_comments = list_comments
        },
        resetStudyEstEukTechMapCommissionStore(state) {
            state.list_comments = []
            state.data_comment = {}
        }
    },

    actions: {
        async updateCommissionStatus({commit, dispatch}, commission_status) {
            const response = await StudyEstEukTechMapCommissionApi.update(commission_status);

            if (_.isNull(response)) return;

            dispatch('getCommissionStatuses', {
                technological_map_id: commission_status.technological_map_id,
                role_key: commission_status.role_key
            })
            store.dispatch("studyEstEukTechMap/indexTechnicalMaps")

            if (!response?.data.hasOwnProperty("error")) {

            } else {
                console.log('error')
            }
        },
        async getCommissionStatuses({commit, dispatch}, params) {
            const response = await StudyEstEukTechMapCommissionApi.show(params);

            if (_.isNull(response)) return;
                commit('setListComments', response.data.list_commission_comments)
            if (!response?.data.hasOwnProperty("error")) {

            } else {
                console.log('error')
            }
        },
        async deleteCommissionStatuses({commit, dispatch}, commission_status) {
            const response = await StudyEstEukTechMapCommissionApi.delete(commission_status);

            if (_.isNull(response)) return;
            commit('setListComments', [])

            dispatch('getCommissionStatuses', {
                technological_map_id: commission_status.technological_map_id,
                role_key: commission_status.role_key
            })
            store.dispatch("studyEstEukTechMap/indexTechnicalMaps")

            if (!response?.data.hasOwnProperty("error")) {

            } else {
                console.log('error')
            }
        },
    },
}

export default StudyEstEukTechMapCommissionStore